export default "__VITE_ASSET__DiG7uE$7__";